import MessageHandler from './MessageHandler';

export default MessageHandler;


// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/index.js